export default __webpack_public_path__ + "media/images/temporary/mud-run-6-4813b7e53757a5d6c9e1c4c6c5066b33.jpg";